import React, { useEffect, useState } from 'react'
import { compose, withApollo } from 'react-apollo'

import { Card, Table, Row,DatePicker } from 'antd'
import axios from 'axios'
import moment from 'moment'

const columns = [
  {
    title: 'อันดับ',
    dataIndex: 'rank',
  },
  {
    title: 'ชื่อ User',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'จำนวนที่พบ',
    dataIndex: 'numberOfScanned',
    key: 'numberOfScanned'
  }
]

const UserRanking = () => {
  const [users, setUsers] = useState([])
  const [month, setMonth] = useState(new Date())
  const monthFormat = 'MMM YYYY'
  useEffect(() => {
    const fetchData = async () => {
      const result = await axios.get( `${process.env.REACT_APP_API_ENDPOINT}/rank/top-10/monthly-rank`)
      setUsers(result.data.data.userRankDtoList)
    }

    fetchData()
  }, [])

  const onChange = async (date) => {
    setMonth(date)
    const arr = moment(date).format('YYYY-MM').split('-')
    const result = await axios.get( `${process.env.REACT_APP_API_ENDPOINT}/rank/top-10/monthly-rank` , {
      params: {
        month: `${arr[0]}${arr[1]}`
      }
    })
    setUsers(result.data.data.userRankDtoList)
  }

  return (
    <Card title="User Rankings">
      <Row style={{ marginBottom: 10 }}>
        <DatePicker.MonthPicker
          value={moment(month, monthFormat)}
          placeholder="Select month"
          format={monthFormat}
          onChange={onChange}
        />
      </Row>
      <Table
        rowKey={record => record.id}
        dataSource={users}
        columns={columns}
        pagination={false}
        size="small"
      />
    </Card>
  )
}

export default compose(withApollo)(UserRanking)
